import { RootState } from 'app/store';

export const selectClientPaymentMethods = (state: RootState) =>
  state.client.paymentMethods.all;

export const selectClientCardLastFourDigits = (state: RootState) =>
  state.client.paymentMethods.default?.lastFour || '';

export const selectIsDefaultPaymentMethodSet = (state: RootState) =>
  state.client.paymentMethods.default !== null;

export const selectIsClientPaymentMethodsLoading = (state: RootState) =>
  state.client.paymentMethods.isLoading;
